import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getParentAvatar } from '../constants/avatars';
import './Header.css';

function Header() {
  const location = useLocation();
  const isParentView = location.pathname === '/parent';
  const { currentUser, signInWithGoogle, logout } = useAuth();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleProfileClick = async () => {
    // Check if user is anonymous (not signed in with Google)
    if (currentUser && !currentUser.isAnonymous) {
      // User is signed in with Google, show menu
      setShowMenu(!showMenu);
    } else {
      // User is anonymous or not logged in, trigger Google sign-in
      try {
        await signInWithGoogle();
      } catch (error) {
        console.error('Failed to sign in:', error);
      }
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      setShowMenu(false);
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <Link to="/" className="app-name-link">
            <span className="app-name">[theclonebook].ai</span>
          </Link>
        </div>
        <div className="header-right">
          {isParentView ? (
            <Link to="/" className="parent-link">
              Child View
            </Link>
          ) : (
            <Link to="/parent" className="parent-link">
              Parent View
            </Link>
          )}
          <div className="profile-container" ref={menuRef}>
            <div className="header-icon" onClick={handleProfileClick}>
              <img 
                src={getParentAvatar(currentUser)} 
                alt={currentUser?.displayName || 'User'} 
                className="profile-avatar"
              />
            </div>
            {showMenu && currentUser && !currentUser.isAnonymous && (
              <div className="profile-menu">
                <div className="profile-menu-header">
                  <img 
                    src={currentUser.photoURL} 
                    alt={currentUser.displayName || 'User'} 
                    className="profile-menu-avatar"
                  />
                  <div className="profile-menu-info">
                    <div className="profile-menu-name">{currentUser.displayName || 'User'}</div>
                    <div className="profile-menu-email">{currentUser.email}</div>
                  </div>
                </div>
                <div className="profile-menu-divider"></div>
                <button className="profile-menu-item" onClick={handleLogout}>
                  Sign Out
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;

